export default __webpack_public_path__ + "static/media/Newregistration.6762b549.svg";